import script from "./LinkedInProfileTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./LinkedInProfileTab.vue?vue&type=script&setup=true&lang=ts"

import "./LinkedInProfileTab.vue?vue&type=style&index=0&id=3e152e8c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e152e8c"]])

export default __exports__